import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { colors } from '../../utilities/colors'
import useTransportationBasePath from '../../hooks/useTransportationBasePath'

export default function CarpoolNav() {
  const { t } = useTranslation()
  const base = useTransportationBasePath()

  const tabs = [
    { label: t('Units'), to: base, end: true },
    { label: t('Quotes'), to: `${base}/quotes`, end: false },
    { label: t('Orders'), to: `${base}/orders`, end: false },
  ]

  return (
    <Box display="flex" borderBottom="1px solid" borderColor={colors.grey700} mb={4}>
      {tabs.map(({ label, to, end }) => (
        <NavLink key={to} to={to} end={end}>
          {({ isActive }) => (
            <Box
              px={4}
              py={2}
              borderBottom="2px solid"
              borderColor={isActive ? colors.green : 'transparent'}
            >
              <Text
                fontSize="sm"
                fontWeight={isActive ? 'semibold' : 'normal'}
                color={isActive ? colors.green : colors.grey300}
              >
                {label}
              </Text>
            </Box>
          )}
        </NavLink>
      ))}
    </Box>
  )
}
